/**
 * Strategy for snapping to ruler marks
 * @param {number} position - Current position
 * @param {number} rulerSnapThreshold - Snap threshold for ruler
 * @param {Object} markIntervals - Ruler mark intervals {major, medium, minor}
 * @returns {Object} Snap result with position and priority
 */
export const rulerMarkSnap = (
  position,
  rulerSnapThreshold = 5,
  markIntervals
) => {
  const intervals = [
    { interval: markIntervals.major, priority: 3 }, // Highest priority
    { interval: markIntervals.medium, priority: 2 },
    { interval: markIntervals.minor, priority: 1 }, // Lowest priority
  ];

  let nearestMark = null;
  let minDistance = rulerSnapThreshold;
  let highestPriority = 0;

  for (const { interval, priority } of intervals) {
    const nearestMultiple = Math.round(position / interval) * interval;
    const distance = Math.abs(position - nearestMultiple);

    // Choose this mark if it's closer, or if it's same distance but higher priority
    if (
      distance < minDistance ||
      (distance === minDistance && priority > highestPriority)
    ) {
      nearestMark = nearestMultiple;
      minDistance = distance;
      highestPriority = priority;
    }
  }

  return {
    position: nearestMark,
    distance: minDistance,
    priority: highestPriority,
    snapped: nearestMark !== null,
  };
};
